import moment from 'moment'

const Helper = {
	install(Vue, options) {
		let normalize = item => item.toString().toLowerCase()
		Vue.filterFieldInclude = function(item, field, value) {
			return normalize(item[field]).includes(normalize(value))
		}
		Vue.filterFieldEquals = function(item, field, value) {
			return normalize(item[field]) === normalize(value)
		}
		Vue.filterFieldFrom = function(item, field, value) {
			let val = moment(value)
			if (!val.isValid()) return true
			return moment(item[field]) >= val
		}
		Vue.filterFieldTo = function(item, field, value) {
			return moment(item[field]) <= moment(value)
		}
	},
}

export default Helper
